const API = process.env.REACT_APP_API_PATH
const USER_API = process.env.REACT_APP_USER_API
// const APP_ID = process.env.REACT_APP_ID
// const TOKEN = localStorage.getItem('currentUserToken')

const request = async (path, options, isBool) => {
  let response = await fetch(path, options)
      .then( res => {
        // console.log(res.status)
        // return res.json()
        if (isBool) return res.status === 200
        return res.json()
          .catch( e => {
            return {error: e}
          } )
      } )
      .catch( e => {
        // console.log(e)
        return {error: e}
      } )
  console.log(path, '\n', response)
  return new Promise( resolve => resolve(response) )
}

// const generateOptions = (method, body) => {
//   return {
//     method: method,
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': TOKEN
//     },
//     body: JSON.stringify(body)
//   }
// }
//
// const generateURL = (query, params) => {
//   let keys = Object.keys(params)
//   if (keys.length === 0) return query
//   let url = query
//   url += '?'
//   for (let i = 0; i < keys.length; i++) {
//     url += `${keys[i]}=${params[keys[i]]}&`
//   }
//   url = url.substr(0, url.length - 1)
//   return url
// }
//
// export const getSearchParams = () => {
//   let path = window.location.search
//   if (!path) return false
//   let string = path.split('?')[1]
//   let options = string.split('&')
//   let result = {}
//   for (let i = 0; i < options.length; i++) {
//     let pairs = options[i].split('=')
//     result[pairs[0]] = pairs[1]
//   }
//   return result
// }
//
// export const authCheck = async () => {
//   const throwUser = () => {
//     localStorage.removeItem('currentUserName')
//     localStorage.removeItem('currentUserPhone')
//     localStorage.removeItem('currentUserToken')
//     window.location.href = window.location.origin
//     return false
//   }
//   if (!TOKEN) return throwUser()
//   let options = generateOptions('GET')
//   let check = await request(`${USER_API}/checkRight/${APP_ID}`, options)
//   if (!check) return throwUser()
//   return true
// }

export const parseDate = (dateString, isDateOnly, isTimeOnly) => {
  if (dateString) {
    let splitted = dateString.split('T')
    let date = `${splitted[0].split('-')[2]}.${splitted[0].split('-')[1]}.${splitted[0].split('-')[0]}`
    let time = splitted[1].split('.')[0]
    if (isDateOnly) return date
    if (isTimeOnly) return time
    return date + ' ' + time
  } else {
    return '---'
  }
}

export const getProjectsList = async () => {
  let path = `${USER_API}/projects`
  let response = await request(path)
  return new Promise(resolve => resolve(response))
}

export const getProjectsDocsList = async () => {
  let path = `${API}/project/get/list`
  // path = 'https://tmc.lll.org.ua/documentation_api/project/get/list'
  let response = await request(path)
  return new Promise(resolve => resolve(response))


  // return new Promise(resolve => resolve(
  //   [
  //     "calculation_api",
  //     "courier_rozenberg_api",
  //     "document_api",
  //     "user_api"
  //   ]
  // ))
}

// export const excelExport = (list) => {
//   let data = []
//   for (let i = 0; i < list.length; i++) {
//     let obj = {}
//     obj['Ключ'] = list[i].key
//     data.push(obj)
//   }
//   const wb = XLSX.utils.book_new()
//   const ws = XLSX.utils.json_to_sheet(data)
//   ws['!cols'] = calcColumnWidth(data)
//   XLSX.utils.book_append_sheet(wb, ws, "Sales")
//   XLSX.writeFile(wb, 'Sales.xlsx')
// }